import {useRef} from 'react'

export default () => {
    const refIsOn = useRef(false)

    const on = map => {
        refIsOn.current = true
        map.canvas.style.userSelect = 'text'
    }

    const off = map => {
        refIsOn.current = false
        const selection = window.getSelection()
        const text = String(selection)
        selection.removeAllRanges()
        map.canvas.style.userSelect = ''

        if (text) {
            navigator.clipboard.writeText(text)
        }
    }

    const watchers = {
        key_down(e) {
            if (refIsOn.current) {
                if ('Alt' !== e.key) {
                    off(this)
                }
            }
            else {
                if (
                    'Alt' === e.key &&
                    ! e.ctrlKey &&
                    ! e.metaKey &&
                    ! e.shiftKey
                ) {
                    on(this)
                }
            }
        },

        key_up(e) {
            if (refIsOn.current) {
                if ('Alt' === e.key) {
                    off(this)
                }
            }
            else {
                if (
                    'Alt' !== e.key &&
                    e.altKey &&
                    ! e.ctrlKey &&
                    ! e.metaKey &&
                    ! e.shiftKey
                ) {
                    on(this)
                }
            }
        }
    }

    return {watchers}
}
